import React, { useMemo, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import PasswordField from './PasswordField';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = useMemo(() => String(searchParams.get('token') || ''), [searchParams]);

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!token) {
      alert('Missing reset token');
      return;
    }
    if (newPassword.length < 8) {
      alert('Password must be at least 8 characters');
      return;
    }
    if (newPassword !== confirmPassword) {
      alert('Passwords do not match');
      return;
    }

    setSubmitting(true);
    try {
      await axios.post('/api/auth/reset-password', { token, newPassword });
      alert('Password updated. You can now sign in.');
      navigate('/login');
    } catch (err) {
      alert(err?.response?.data?.error || 'Reset link is invalid or expired');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div style={{ maxWidth: 420, margin: '40px auto', padding: 20, border: '1px solid #ddd', borderRadius: 8 }}>
      <h2>Reset Password</h2>
      <form onSubmit={handleSubmit} style={{ display: 'grid', gap: 10 }}>
        <PasswordField
          value={newPassword}
          onChange={e => setNewPassword(e.target.value)}
          placeholder="New password"
          name="newPassword"
          autoComplete="new-password"
          required
          ariaLabel="new password"
        />
        <PasswordField
          value={confirmPassword}
          onChange={e => setConfirmPassword(e.target.value)}
          placeholder="Confirm new password"
          name="confirmPassword"
          autoComplete="new-password"
          required
          ariaLabel="confirm password"
        />
        <button type="submit" disabled={submitting}>{submitting ? 'Saving...' : 'Set New Password'}</button>
      </form>
      <div style={{ marginTop: 12 }}>
        <Link to="/login">Back to login</Link>
      </div>
    </div>
  );
}

export default ResetPassword;
